<template>
  <bj-modal
    v-model="matchAnAgent.visible"
    :size="{ minWidth:'450px'}"
    title="Match an agent to inquiry"
  >
    <div slot="content">
      <div
        v-if="matchAnAgent.loading"
        class="text-center"
      >
        <q-spinner-puff
          color="primary"
          size="60px"
        />
      </div>
      <div
        v-else
        class="row gutter-sm align-items-center"
      >
        <div class="col-9">
          <autocomplete
            :disable="isShowami"
            method="autocompleteAgent"
            :filters="{
              is_tours_capable: true,
              property_id: get(matchAnAgent, 'payload.inquiry.property_id')
                || get(matchAnAgent, 'payload.inquiry.tour.property_id'),
            }"
            placeholder="Find an agent..."
            @change="matchAnAgentSelected"
          />
        </div>
        <div class="col-3">
          <q-btn
            :disabled="!matchAnAgent.payload.agent"
            outline
            class="full-width"
            label="Match!"
            @click="submitMatchAnAgent"
          />
        </div>
        <div class="col-12 text-right">
          <q-btn
            v-if="!isShowami"
            class="mt-2"
            size="sm"
            color="warning"
            outline
            label="Assign to Showami"
            @click="submitAssignToShowami"
          />
        </div>
        <div
          v-if="isShowami"
          class="text-warning"
        >
          Schedule currently assigned to showami.
        </div>
      </div>
    </div>
  </bj-modal>
</template>

<script>
import get from 'lodash.get';
import Autocomplete from '@/components/autocomplete.vue';

export default {
  name: 'BjMatchAgentModal',
  components: { Autocomplete },
  props: {
    matchAnAgent: {
      type: Object,
      required: true,
    },
    includeUnverified: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isShowami() {
      if (this.matchAnAgent.payload.inquiry) {
        return this.matchAnAgent.payload.inquiry.schedule_inquiry.schedule.is_showami;
      }
      return false;
    },
    schedule_id() {
      if (this.matchAnAgent.payload.inquiry) {
        return this.matchAnAgent.payload.inquiry.schedule_inquiry.schedule_id;
      }
      return null;
    },
  },
  methods: {
    get,
    matchAnAgentSelected(event) {
      const { item } = event;
      this.matchAnAgent.payload.agent = item.data;
    },
    submitMatchAnAgent() {
      const { agent } = this.matchAnAgent.payload;
      if (agent) {
        const tourExperiencedAgent = agent.is_tours_experienced ? '(Experienced)' : '';
        const agentName = agent.manuallySelected ? `Agent #${agent.id}` : `${agent.full_name} ${tourExperiencedAgent}`;
        this.uiConfirm(`Are you sure you want to match this inquiry to ${agentName}?`).then(() => {
          this.matchAnAgent.loading = true;
          this.api().request('POST', `schedules/${this.schedule_id}/match`, {
            agent_id: agent.id,
          }).then((response) => {
            this.matchAnAgent.loading = false;
            this.uiNotify('Inquiry matched successfully');
            this.$root.$emit('agent-matched', response);
          }).catch((error) => {
            this.matchAnAgent.loading = false;
            this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative');
          });
        });
      }
    },
    submitAssignToShowami() {
      this.uiConfirm('Are you sure you want to assign this schedule to Showami?').then(() => {
        this.matchAnAgent.loading = true;
        this.api().request('POST', `admin/showami/${this.schedule_id}`).then((response) => {
          this.matchAnAgent.loading = false;
          this.uiNotify('Schedule successfully assigned to Showami');
          this.$root.$emit('agent-matched', response);
        }).catch((error) => {
          this.matchAnAgent.loading = false;
          this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative');
        });
      });
    },
  },
};
</script>
